import { Button } from 'antd';
import { connect } from 'react-redux';
import LoadingBtn from './LoadingSpinner';
import React, { Fragment } from 'react';
import { Btn, PaveColor } from '../components/ConfigStyle';

const PaveButton = (props) => {
  const {
    title,
    fontS,
    width,
    color,
    type_3,
    type_2,
    height,
    padding,
    bgColor,
    className,
    btnLoading,
    marginLeft,
    handleSubmit,
  } = props;
  return (
    <Btn>
      {type_3 ? (
        <Button
          onClick={btnLoading ? null : handleSubmit}
          style={{
            border: 'none',
            outline: 'none',
            overflow: 'hidden',
            fontWeight: 'bold',
            textAlign: 'center',
            letterSpacing: '1px',
            borderRadius: '10px',
            textTransform: 'uppercase',
            color: `${color ? color : 'white'}`,
            width: `${width ? width : 'unset'}`,
            height: `${height ? height : '40px'}`,
            fontSize: `${fontS ? fontS : ' 12px'}`,
            lineHeight: `${height ? height : '40px'}`,
            padding: `${padding ? padding : '0 30px'}`,
            marginLeft: `${marginLeft ? marginLeft : '0'}`,
            background: btnLoading ? PaveColor.disabled : bgColor,
          }}
        >
          {title}
        </Button>
      ) : type_2 ? (
        <div
          style={{
            width: width ? `${parseInt(width) + 1}rem` : '4rem',
            height: height ? `${parseInt(height) + 1}rem` : '4rem',
            borderRadius: '100%',
            background: btnLoading ? PaveColor.disabled : bgColor,
            position: 'relative',
          }}
        >
          <Button
            className=""
            disabled={btnLoading ? true : false}
            style={{
              width: width ? `${width}rem` : '3.5rem',
              height: height ? `${height}rem` : '3.5rem',
              borderRadius: '100%',
              fontSize: fontS ? fontS : '12px',
              textAlign: 'center',
              background: btnLoading ? PaveColor.disabled : bgColor,
              color: '#fff',
              whiteSpace: 'pre-wrap',
              padding: '0',
              position: 'absolute',
              margin: 'auto',
              border: '2px solid #fff',
              top: '0',
              right: '0',
              left: '0',
              bottom: '0',
              fontWeight: '600',
              overflow: 'hidden',
            }}
            onClick={btnLoading ? null : handleSubmit}
          >
            {title}
          </Button>
        </div>
      ) : (
        <Button
          style={{
            border: 'none',
            outline: 'none',
            overflow: 'hidden',
            fontWeight: 'bold',
            textAlign: 'center',
            letterSpacing: '1px',
            borderRadius: '400px',
            textTransform: 'uppercase',
            color: `${color ? color : 'white'}`,
            width: `${width ? width : 'unset'}`,
            height: `${height ? height : '40px'}`,
            fontSize: `${fontS ? fontS : ' 12px'}`,
            lineHeight: `${height ? height : '40px'}`,
            padding: `${padding ? padding : '0 30px'}`,
            marginLeft: `${marginLeft ? marginLeft : '0'}`,
            background: btnLoading ? PaveColor.disabled : bgColor,
          }}
          onClick={btnLoading ? null : handleSubmit}
          className={`ripple ${className ? className : 'pave-btn-default'}`}
        >
          {btnLoading ? <LoadingBtn /> : <Fragment>{title}</Fragment>}
        </Button>
      )}
    </Btn>
  );
};
const mapStateToProps = (state) => ({
  netWorkStatus: state.userDetailsReducer.defaultNetWork,
});

export default connect(mapStateToProps, null)(React.memo(PaveButton));
